import React, { useState, useEffect } from 'react'
import './BlurOverlay.scss'

const BlurOverlay = ({ isOverlayOpen, section }) => {
  const [openOverlay, setOpenOverlay] = useState(false)
  const [overlayClassList, setOverlayClassList] = useState('')

  useEffect(() => {
    isOverlayOpen ? handleOpenOverlay() : handleCloseOverlay()
    if (section === 'menuMain') {

      const blurOverlayEl = document.getElementById('blur-overlay')
      isOverlayOpen ? setOverlayClassList('mobile-menu-expanded') : setOverlayClassList('')
    }
  }, [isOverlayOpen])

  function handleOpenOverlay() {
    document.body.classList.add('disable-scroll', 'overflow-hidden')
    setOpenOverlay(true)
  }

  function handleCloseOverlay() {
    document.body.classList.remove('disable-scroll', 'overflow-hidden')
    setOpenOverlay(false)
  }

  if (!openOverlay) {
    return null
  }

  return (
    <>
      <div id={'blur-overlay'} className={overlayClassList}></div>
    </>
  )
}

export default BlurOverlay